// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueSelectBox.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorValueSelexBox component
 */
!(function() {
  var stringUtils = require('share/utils/Izenda.StringUtilities');
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var constants = require('logic/data/Izenda.FilterDetailsConfigConstants');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var Select = Validator()(require('share/components/controls/multiSelectBox/Izenda.Select'));
  var Input = require('share/components/controls/Izenda.Input');
  const ALL = constants.DEFAUFT_VALUE.ALL;
  const BLANK = constants.DEFAUFT_VALUE.BLANK;
  const NULL = constants.DEFAUFT_VALUE.NULL;
  const { identity, map, concat, isNil, filter, isEmpty, isArray, placeholder } = require('lodash/fp');

  const OPTION_ALL = {
    value: ALL,
    label: ALL
  };
  const OPTION_BLANK = {
    value: BLANK,
    label: BLANK
  };

  const OPTION_NULL = {
    value: NULL,
    label: NULL
  };

  var OperatorValueSelectBox = React.createClass({
    /**
     * Define property type
     */
    propTypes: {
      filterSource: React.PropTypes.object.isRequired,
      filterInfo: React.PropTypes.object.isRequired,
      viewMode: React.PropTypes.bool,
      applyFormater: React.PropTypes.func
    },

    getDefaultProps: function() {
      return {
        applyFormater: identity
      };
    },

    /**
     * Define initial state
     */
    getInitialState: function() {
      return {
        value: null,
        validInput: true,
        options: [],
        errorMessage: ''
      };
    },

    /**
     * Populate options.
     */
    populateOptions: function(filterSource) {
      // Convert obser array to array
      var filterSourceArray = filterSource.length && filterSource.slice();

      var defaultOption = [OPTION_ALL, OPTION_BLANK, OPTION_NULL];

      var applyFormater = this.props.applyFormater;

      var dataOptions = map(function(item) {
        return {
          value: item,
          label: applyFormater(item)
        };
      }, filterSourceArray);

      this.setState({
        options: concat(defaultOption, dataOptions)
      });
    },

    componentWillMount: function() {
      this.populateOptions(this.props.filterSource);
    },

    /**
     * Handle when receive react property
     * @param  {object} nextProps react property
     */
    componentWillReceiveProps: function(nextProps) {
      this.populateOptions(nextProps.filterSource);

      // Get error message for validate format base on data type
      var dataType = this.props.operatorGroup.fieldDetails.dataType;
      var errorMessage = this.getDataByKey(constants.ERROR_MESSAGE_BY_DATA_TYPE, dataType);

      this.setState({
        errorMessage: errorMessage
      });
    },

    /**
     * get error message by key
     * @param  {object} object error message collection
     * @param  {string} key    key
     * @return {string}
     */
    getDataByKey: function(object, key) {
      return placeholder(object).get(key);
    },

    /**
     * Handle switch component to select multiple or signle
     * @param  {object} e React event
     */
    switchToSingleOrMultiple: function(value) {
      var validation = this.props.validation;

      validation.reset();

      var isMultipleMode = this.checkMultipleMode(this.props.operatorGroup.fieldDetails.operatorSetting);
      var isMultipleCheck = this.checkMultipleMode(value);
      var sourceValue = this.props.filterInfo.value;
      var values = this.getValueFromSource(sourceValue.sort()) || [];

      if (isMultipleMode === isMultipleCheck) {
        return;
      }

      var result = isMultipleCheck ? [values.value] : values.length > 0 ? [values[0].value] : [];

      this.props.onChange && this.props.onChange(result);
      this.props.operatorGroup.fieldDetails.setOperatorSetting(value);
    },

    /**
     * Handle switch component to signle
     */
    swithToSingle: function() {
      this.switchToSingleOrMultiple(constants.SELECT_SETTINGS.SINGLE);
    },

    /**
     * Handle switch component to multiple
     */
    switchToMultiple: function() {
      this.switchToSingleOrMultiple(constants.SELECT_SETTINGS.MULTIPLE);
    },

    /**
     * Handle when change value of selectbox
     * @param  {object} selectValues list select value
     */
    onChangeSelect: function(selectValues) {
      // when remove value
      if (isNil(selectValues) || (selectValues && selectValues.length === 0)) {
        this.props.onChange && this.props.onChange([]);
        return;
      }

      const isMultipleMode = this.checkMultipleMode(this.props.operatorGroup.fieldDetails.operatorSetting);
      let result;

      if (isMultipleMode) {
        result =
          selectValues[selectValues.length - 1].value === ALL
            ? [ALL]
            : map(
                function(item) {
                  return item.value;
                },
                filter(function(item) {
                  return item.value !== ALL && !isEmpty(item.value);
                }, selectValues)
              );
      } else {
        result = map(function(item) {
          return item.value;
        }, selectValues);
      }

      this.props.onChange && this.props.onChange(result);
    },

    /**
     * Handle when add new value of selectbox
     * @param  {object} newValue new value of select box
     * @return {boolean}         result of add new value
     */
    onAddNewSelect: function(newValue) {
      if (this.props.isSelect) {
        return false;
      }
      const { operatorGroup:
        { fieldDetails:
          {
            dataType,
            useLookup
          }
        }
      } = this.props;

      if (!this.validationValue(newValue.value, useLookup ? DATA_TYPE.TEXT : dataType)) {
        var valManager = this.props.validation;

        valManager.updateErrors([
          { key: constants.CONSTRAINTS_NAME + this.props.index, messages: this.state.errorMessage }
        ]);
        return false;
      }

      return true;
    },

    /**
     * Validation when add new value for selectbox
     * @param  {object} value    validate value
     * @param  {string} dataType data type of value
     * @return {boolean}         result of validate
     */
    validationValue: function(value, dataType) {
      switch (dataType) {
        case constants.DATA_TYPE.TEXT:
          return true;
        case constants.DATA_TYPE.MONEY:
        case constants.DATA_TYPE.NUMBER:
          return String.isPatternFormat(value, constants.REGEX.NUMBER);
        case constants.DATA_TYPE.DATE:
          return String.isPatternFormat(value, constants.REGEX.DATETIMEFORMAT);
        default:
          return true;
      }
    },

    /**
     * Get value from source for selectbox
     * @param  {array} filter value
     * @return         array or object base on component multiple or single settings
     */
    getValueFromSource: function(source) {
      var applyFormater = this.props.applyFormater;

      var result;
      var isMultipleMode = this.checkMultipleMode(this.props.operatorGroup.fieldDetails.operatorSetting);

      if (isMultipleMode) {
        result = isArray(source)
          ? map(function(item) {
              return { value: item, label: applyFormater(item) };
            }, source)
          : [];
        // Remove empty value
        if (result.length === 1 && isEmpty(result[0].value)) {
          result = [];
        }
      } else {
        result = isArray(source) && !isEmpty(source[0]) ? { value: source[0], label: applyFormater(source[0]) } : null;
      }
      return result;
    },

    /*
     */
    checkMultipleMode: function(value) {
      return value === constants.SELECT_SETTINGS.MULTIPLE;
    },

    renderSelectBox: function() {
      var fieldDetails = this.props.operatorGroup.fieldDetails;
      var isMultipleMode = this.checkMultipleMode(fieldDetails.operatorSetting);

      return this.props.viewMode ? null : (
        <div>
          <Input
            type='radio'
            checked={!isMultipleMode}
            onChange={this.swithToSingle}
            value={constants.SELECT_SETTINGS.SINGLE}
            disabled={this.props.disabled}
          />
          {constants.SELECT_MODE.SINGLE} &nbsp;
          <Input
            type='radio'
            checked={isMultipleMode}
            onChange={this.switchToMultiple}
            value={constants.SELECT_SETTINGS.MULTIPLE}
            disabled={this.props.disabled}
          />{' '}
          {constants.SELECT_MODE.MULTIPLE}
        </div>
      );
    },

    /**
     * Render component
     */
    render: function() {
      var props = this.props;
      var sourceValue = props.filterInfo.value;
      var isMultipleMode = this.checkMultipleMode(props.operatorGroup.fieldDetails.operatorSetting);
      var values = this.getValueFromSource(sourceValue);

      var constraints = constants.CONSTRAINTS;

      return (
        <div className='manual-entry'>
          {this.renderSelectBox()}
          <div className='select-box-container'>
            <Select
              multi={isMultipleMode}
              options={this.state.options}
              labelKey={props.labelField}
              valueKey={props.valueField}
              scalable={false}
              value={values}
              onChange={this.onChangeSelect}
              onAddNew={this.onAddNewSelect}
              field={constants.CONSTRAINTS_NAME + props.index}
              validations={constraints}
              disabled={props.disabled}
              inputMaxHeight={85}
            />
          </div>
        </div>
      );
    }
  });

  module.exports = connect()(OperatorValueSelectBox);
})();



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueSelectBox.jsx